import UserInformation from 'assets/images/sidebar/userInformation.svg'
import Asset from 'assets/images/sidebar/asset.svg'
import AccountNumber from 'assets/images/sidebar/accountNumber.svg'
import ContactSupport from 'assets/images/sidebar/cuntactSupport.svg'
import Share from 'assets/images/sidebar/share.svg'
import Exit from 'assets/images/sidebar/exit.svg'
import NationalImage from 'assets/images/sidebar/ic_id_card.svg'
interface ISidebarItemsProps {
    id: number
    icon: string
    text: string
    route: string
}
/**
 * Sidebar menu.
 *
 * Every entry here must lead somewhere real. Eight used to point at `/`, which
 * silently bounced the user to the home page, and four more replaced the whole
 * document with hamyanapp.com — which strands a mini-app user with no way back,
 * since the messenger webview has no address bar and the hardware back button
 * closes the app.
 *
 * The old `isDisable` flag is gone: it was never read by the component, so
 * "disabled" placeholders rendered and navigated exactly like working items.
 * A flag nothing enforces is worse than no flag.
 */
export const sideBarItems: Array<ISidebarItemsProps> = [
    {
        id: 0,
        icon: UserInformation,
        text: 'اطلاعات کاربری',
        route: '/account/profile',
    },
    {
        id: 20,
        icon: NationalImage,
        text: 'احراز هویت با کدملی',
        route: '/authentication_with_national_code',
    },
    {
        id: 1,
        icon: Asset,
        text: 'کیف پول',
        route: '/wallet',
    },
    {
        id: 2,
        icon: AccountNumber,
        text: 'مدیریت کارت‌های بانکی',
        route: '/manage-bank-cards',
    },
    {
        id: 5,
        icon: ContactSupport,
        text: 'پیام به پشتیبانی',
        route: '/',
    },
    {
        id: 9,
        icon: Share,
        text: 'اشتراک‌گذاری برنامه',
        route: '/',
    },
    {
        id: 13,
        icon: Exit,
        text: 'خروج از حساب‌کاربری',
        route: '/home',
    },
]
